// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-sidebar-CustomModelBox-module__customModelBox {
    margin: 0.6em 0;
    padding: 0 0;
    border-top: lightgray solid 1px;
    height: 18rem;
}

.src-sidebar-CustomModelBox-module__customModelOptionTable {
    display: grid;
    font-size: 14px;
    grid-template-columns: 50px auto 50px;
    grid-template-rows: 1.3rem;
    align-content: center;
    align-items: center;
    margin: 1.5rem 0.5rem 0.5rem 0;
}

.src-sidebar-CustomModelBox-module__customModelOptionTable svg {
    scale: 0.7;
}

.src-sidebar-CustomModelBox-module__drawAreas {
    justify-content: end;
    scale: 0.8;
}

#src-sidebar-CustomModelBox-module__element::-webkit-scrollbar {
    display: none;
}

.src-sidebar-CustomModelBox-module__customModelBoxBottomBar {
    display: flex;
    border-bottom: lightgray solid 1px;
}

.src-sidebar-CustomModelBox-module__helpLink {
    text-decoration: none;
    flex-grow: 1;
}

.src-sidebar-CustomModelBox-module__examples,
.src-sidebar-CustomModelBox-module__helpLink,
.src-sidebar-CustomModelBox-module__applyButton button {
    font-size: 14px;
}

.src-sidebar-CustomModelBox-module__examples {
    border: none;
    border-top: #ececec solid 1px;
    border-right: #ececec solid 1px;
    padding-left: 1em;
    margin-left: 0;
    background-color: white;
    color: rgba(0, 60, 136, 0.7);
}

.src-sidebar-CustomModelBox-module__examples option {
    background-color: white;
    color: rgba(0, 60, 136, 0.7);
}

/* show disabled button while route calculation */
.src-sidebar-CustomModelBox-module__applyButtonProgress button,
.src-sidebar-CustomModelBox-module__applyButtonInvalid button {
    cursor: default !important;
    color: lightgray !important;
}

.src-sidebar-CustomModelBox-module__infiniteProgressBar {
    animation: src-sidebar-CustomModelBox-module__progress 4s infinite normal;
    height: 2px;
    margin-top: -2px; /* when visible it should not occupy space */
    background-color: rgb(65, 121, 0);
}

@keyframes src-sidebar-CustomModelBox-module__progress {
    0% {
        width: 0;
        margin-left: 0;
    }
    50% {
        width: 100%;
        margin-left: 0;
    }
    100% {
        width: 0;
        margin-left: 100%;
    }
}

.src-sidebar-CustomModelBox-module__helpLink:hover {
    color: black;
}

.src-sidebar-CustomModelBox-module__helpLink,
.src-sidebar-CustomModelBox-module__examples {
    cursor: pointer;
    color: #5b616a;
}

.src-sidebar-CustomModelBox-module__applyButton button {
    background-color: rgb(124, 179, 66, 0.1);
}

.src-sidebar-CustomModelBox-module__applyButton button,
.src-sidebar-CustomModelBox-module__helpLink {
    padding: 0.8em 1.7em;
}
`, "",{"version":3,"sources":["webpack://./src/sidebar/CustomModelBox.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,+BAA+B;IAC/B,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,qCAAqC;IACrC,0BAA0B;IAC1B,qBAAqB;IACrB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;;IAGI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,+BAA+B;IAC/B,iBAAiB;IACjB,cAAc;IACd,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA,iDAAiD;AACjD;;IAEI,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,yEAAsC;IACtC,WAAW;IACX,gBAAgB,EAAE,4CAA4C;IAC9D,iCAAiC;AACrC;;AAEA;IACI;QACI,QAAQ;QACR,cAAc;IAClB;IACA;QACI,WAAW;QACX,cAAc;IAClB;IACA;QACI,QAAQ;QACR,iBAAiB;IACrB;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;;IAEI,oBAAoB;AACxB","sourcesContent":[".customModelBox {\n    margin: 0.6em 0;\n    padding: 0 0;\n    border-top: lightgray solid 1px;\n    height: 18rem;\n}\n\n.customModelOptionTable {\n    display: grid;\n    font-size: 14px;\n    grid-template-columns: 50px auto 50px;\n    grid-template-rows: 1.3rem;\n    align-content: center;\n    align-items: center;\n    margin: 1.5rem 0.5rem 0.5rem 0;\n}\n\n.customModelOptionTable svg {\n    scale: 0.7;\n}\n\n.drawAreas {\n    justify-content: end;\n    scale: 0.8;\n}\n\n#element::-webkit-scrollbar {\n    display: none;\n}\n\n.customModelBoxBottomBar {\n    display: flex;\n    border-bottom: lightgray solid 1px;\n}\n\n.helpLink {\n    text-decoration: none;\n    flex-grow: 1;\n}\n\n.examples,\n.helpLink,\n.applyButton button {\n    font-size: 14px;\n}\n\n.examples {\n    border: none;\n    border-top: #ececec solid 1px;\n    border-right: #ececec solid 1px;\n    padding-left: 1em;\n    margin-left: 0;\n    background-color: white;\n    color: rgba(0, 60, 136, 0.7);\n}\n\n.examples option {\n    background-color: white;\n    color: rgba(0, 60, 136, 0.7);\n}\n\n/* show disabled button while route calculation */\n.applyButtonProgress button,\n.applyButtonInvalid button {\n    cursor: default !important;\n    color: lightgray !important;\n}\n\n.infiniteProgressBar {\n    animation: progress 4s infinite normal;\n    height: 2px;\n    margin-top: -2px; /* when visible it should not occupy space */\n    background-color: rgb(65, 121, 0);\n}\n\n@keyframes progress {\n    0% {\n        width: 0;\n        margin-left: 0;\n    }\n    50% {\n        width: 100%;\n        margin-left: 0;\n    }\n    100% {\n        width: 0;\n        margin-left: 100%;\n    }\n}\n\n.helpLink:hover {\n    color: black;\n}\n\n.helpLink,\n.examples {\n    cursor: pointer;\n    color: #5b616a;\n}\n\n.applyButton button {\n    background-color: rgb(124, 179, 66, 0.1);\n}\n\n.applyButton button,\n.helpLink {\n    padding: 0.8em 1.7em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customModelBox": `src-sidebar-CustomModelBox-module__customModelBox`,
	"customModelOptionTable": `src-sidebar-CustomModelBox-module__customModelOptionTable`,
	"drawAreas": `src-sidebar-CustomModelBox-module__drawAreas`,
	"element": `src-sidebar-CustomModelBox-module__element`,
	"customModelBoxBottomBar": `src-sidebar-CustomModelBox-module__customModelBoxBottomBar`,
	"helpLink": `src-sidebar-CustomModelBox-module__helpLink`,
	"examples": `src-sidebar-CustomModelBox-module__examples`,
	"applyButton": `src-sidebar-CustomModelBox-module__applyButton`,
	"applyButtonProgress": `src-sidebar-CustomModelBox-module__applyButtonProgress`,
	"applyButtonInvalid": `src-sidebar-CustomModelBox-module__applyButtonInvalid`,
	"infiniteProgressBar": `src-sidebar-CustomModelBox-module__infiniteProgressBar`,
	"progress": `src-sidebar-CustomModelBox-module__progress`
};
export default ___CSS_LOADER_EXPORT___;
